'use client';

/**
 * `useClaimGift` — delegates to the host's implementation.
 * See `./host-context.tsx` for the rationale.
 */
import { useGiftingHostContext } from './host-context.js';
export function useClaimGift() {
  const {
    useClaimGift: impl
  } = useGiftingHostContext();
  return impl();
}